import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import RecurringTransferCreateModalUI from './RecurringTransferCreateModalUI.js'

class RecurringTransferCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      bankDetailsVerified: false,
      // form field
      interval: '',
      intervalError: null,
      paymentAmount: '',
      paymentAmountError: null,
      ifscCode: '',
      ifscCodeError: null,
      bankAccountNumber: '',
      bankAccountNumberError: null,
      startDate: '',
      startDateError: null,
      endDate: '',
      endDateError: null
    }
  }

  render() {
    let intervalList = [
      { key: 'daily', value: 'Daily' },
      { key: 'weekly', value: 'Weekly' },
      { key: 'monthly', value: 'Monthly' },
    ]
    let daysList = [
      { key: '1', value: 'Mon' },
      { key: '2', value: 'Tue' },
      { key: '3', value: 'Wed' },
      { key: '4', value: 'Thu' },
      { key: '5', value: 'Fri' },
      { key: '6', value: 'Sat' },
      { key: '7', value: 'Sun' },
    ]
    let monthList = [
      { key: '1', value: '1' },
      { key: '2', value: '2' },
      { key: '3', value: '3' },
      { key: '4', value: '4' },
      { key: '5', value: '5' },
      { key: '6', value: '6' },
      { key: '7', value: '7' },
      { key: '8', value: '8' },
      { key: '9', value: '9' },
      { key: '10', value: '10' },
      { key: '11', value: '11' },
      { key: '12', value: '12' },
      { key: '13', value: '13' },
      { key: '14', value: '14' },
      { key: '15', value: '15' },
      { key: '16', value: '16' },
      { key: '17', value: '17' },
      { key: '18', value: '18' },
      { key: '19', value: '19' },
      { key: '20', value: '20' },
      { key: '21', value: '21' },
      { key: '22', value: '22' },
      { key: '23', value: '23' },
      { key: '24', value: '24' },
      { key: '25', value: '25' },
      { key: '26', value: '26' },
      { key: '27', value: '27' },
      { key: '28', value: '28' },
      { key: '29', value: '29' },
      { key: '30', value: '30' },
      { key: '31', value: '31' },
    ]
    return (
      <RecurringTransferCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        bankDetailsVerified={this.state.bankDetailsVerified}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        onVerifyBankDetailsClick={this.onVerifyBankDetailsClick}
        // form fields
        interval={this.state.interval}
        onIntervalChange={(event) => { this.setState({ interval: event.target.value }) }}
        intervalError={this.state.intervalError}
        setIntervalError={(error) => { this.setState({ intervalError: error }) }}
        intervalList={intervalList}
        //
        startDate={this.state.startDate}
        onStartDateChange={(selectedDateISO) => { this.setState({ startDate: selectedDateISO }) }}
        startDateError={this.state.startDateError}
        setStartDateError={(error) => { this.setState({ startDateError: error }) }}
        //
        endDate={this.state.endDate}
        onEndDateChange={(selectedDateISO) => { this.setState({ endDate: selectedDateISO }) }}
        endDateError={this.state.endDateError}
        setEndDateError={(error) => { this.setState({ endDateError: error }) }}
        //
        dayOfWeek={this.state.dayOfWeek}
        onDayOfWeekChange={(event) => { this.setState({ dayOfWeek: event.target.value }) }}
        dayOfWeekError={this.state.dayOfWeekError}
        setDayOfWeekError={(error) => { this.setState({ dayOfWeekError: error }) }}
        daysList={daysList}
        //
        dayOfMonth={this.state.dayOfMonth}
        onDayOfMonthChange={(event) => { this.setState({ dayOfMonth: event.target.value }) }}
        dayOfMonthError={this.state.dayOfMonthError}
        setDayOfMonthError={(error) => { this.setState({ dayOfMonthError: error }) }}
        monthList={monthList}
        //
        paymentAmount={this.state.paymentAmount}
        onPaymentAmountChange={(event) => { this.setState({ paymentAmount: event.target.value }) }}
        paymentAmountError={this.state.paymentAmountError}
        setPaymentAmountError={(error) => { this.setState({ paymentAmountError: error }) }}
        //
        ifscCode={this.state.ifscCode}
        onIfscCodeChange={(event) => { this.setState({ ifscCode: event.target.value }) }}
        ifscCodeError={this.state.ifscCodeError}
        setIfscCodeError={(error) => { this.setState({ ifscCodeError: error }) }}
        //
        bankAccountNumber={this.state.bankAccountNumber}
        onBankAccountNumberChange={(event) => { this.setState({ bankAccountNumber: event.target.value }) }}
        bankAccountNumberError={this.state.bankAccountNumberError}
        setBankAccountNumberError={(error) => { this.setState({ bankAccountNumberError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onVerifyBankDetailsClick = () => {
    this.setState({
      successMsg: null,
      errorList: [],
      bankDetailsVerified: true
    })

    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/ifsc/${this.state.ifscCode}/bankAccounts/${this.state.bankAccountNumber}`,
      this.onVerifyBankDetailsClickCallback, {}
    )
  }

  onVerifyBankDetailsClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      bankDetailsVerified: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 4000)
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scheduledTasks`,
      this.onSubmitCallback, {
      interval: 'daily',
      startDateISO: this.state.startDate,
      endDateISO: this.state.endDate,
      dayOfWeek: this.state.dayOfWeek,
      dayOfMonth: this.state.dayOfMonth,
      paymentAmountF: this.state.paymentAmount,
      ifscCode: this.state.ifscCode,
      bankAccountNumber: this.state.bankAccountNumber
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onCancelClick()
        this.props.onRefreshClick()
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onCancelClick = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      submitted: false,
      interval: '',
      startDate: '',
      endDate: '',
      dayOfWeek: '',
      dayOfMonth: '',
      paymentAmount: '',
      ifscCode: '',
      bankAccountNumber: '',
    })
    this.props.onCancelClick()
  }
}

export default RecurringTransferCreateModalSF
